import type { ReactNode } from "react";
import Icon from "@/components/Icon";
import Tooltip from "@/components/Tooltip";
import { isTokenizedAccountNumber, TOKENIZED_ACCOUNT_NUMBER_STAFF_NOTICE } from "../tokenizedAccountNumber";

interface TokenizedAccountNumberHintProps {
  maskedNumber?: string | null;
  identifierType?: string | null;
  emptyFallback?: ReactNode;
}

export default function TokenizedAccountNumberHint({
  maskedNumber,
  identifierType,
  emptyFallback = <span className="opacity-20">--</span>
}: TokenizedAccountNumberHintProps) {
  const display = maskedNumber || emptyFallback;

  if (!isTokenizedAccountNumber(identifierType) || !maskedNumber) {
    return <>{display}</>;
  }

  return (
    <span className="inline-flex items-center gap-1" data-testid="tokenized-account-number-hint">
      <span>{maskedNumber}</span>
      <Tooltip
        variant="plain"
        color="black"
        supportingText={TOKENIZED_ACCOUNT_NUMBER_STAFF_NOTICE}
        menuCorner="end-start"
        anchorCorner="start-start"
      >
        <Icon name="info" size={18} className="text-sys-brand-on-surface-variant" />
      </Tooltip>
    </span>
  );
}
